import React, { useEffect } from "react";
import {
  Authenticator,
  ThemeProvider,
  Theme,
  View,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { useAuthStore } from "@/stores/authStore";

const theme: Theme = {
  name: "custom-theme",
  tokens: {
    fonts: {
      default: {
        variable: '"Inter", sans-serif',
        static: '"Inter", sans-serif',
      },
    },
    components: {
      authenticator: {
        router: {
          boxShadow: "none",
          borderWidth: "0px",
        },
      },
      card: {
        backgroundColor: "white",
      },
      tabs: {
        item: {
          _active: {
            borderColor: "black",
            color: "black",
          },
          color: "#777",
        },
      },
      button: {
        primary: {
          backgroundColor: "black",
          color: "white",
          _hover: {
            backgroundColor: "#333333",
          },
        },
      },
    },
  },
};

export const StyledAuthenticator: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { user, fetchUser } = useAuthStore();

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <View className="bg-slate-50 flex justify-center items-start h-screen">
        <Authenticator
          hideSignUp
          className="m-16 rounded-b-lg border bg-card shadow-md overflow-hidden"
        >
          {() => <View>{children}</View>}
        </Authenticator>
      </View>
    </ThemeProvider>
  );
};
